import React, { useMemo, useState } from "react";
import { Trans } from "react-i18next";
import AddAttendance from "./AddAttendance";
import { Card, CardBody, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, TabContent, TabPane, UncontrolledButtonDropdown } from "reactstrap";
import ImportModal from "components/ImportModal";
import { ApiClient } from "services";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import download from "downloadjs";
import AttendanceTable from "./Attendance";

export const EmployeeAttendance = ({ employee, client, t, match, limit }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [activeTab, setActiveTab] = useState("1");

    const apiClient = ApiClient();

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const download_file = (event) => {
        event.preventDefault();
        client.get(`employees/${employee.id}/attendance/download_template?month=${selectedMonth}`).get('data').then(({ data }) => {
            download(data, `attendance_template_${selectedMonth}.xlsx`);
        })
    }

    const uploadFile = async (file) => {
        try {
            let selectedFile = file
            const formData = new FormData();
            formData.append('employee_id', employee.id)
            formData.append('id', employee.connected_organisation)
            formData.append('file', selectedFile)
            formData.append('salary_type_value', 'base')

            apiClient
                .post('import_bulk_attendance', formData)
                .then(({ data }) => {
                    NotificationManager.success(t("Uploaded successfully"));
                    closeModal()
                })
        } catch (err) {
            NotificationManager.error(t('Error while Upload'));
        }
    };


    const getLast6Months = () => {
        const months = [];

        for (let i = 11; i >= 0; i--) {
            const m = moment().subtract(i, "months");
            const label = m.format("MMMM-YY"); // e.g., "July/25"
            const value = m.format("YYYY-MM"); // e.g., "2025-07"
            months.push({ label, value });
        }

        return months;
    };
    const last_12_months = useMemo(() => getLast6Months(), []);



    if (!employee) return null;

    return (
        <Card className="shadow-sm border">
            <CardBody>
                <div className="row mb-3 justify-content-between mx-1">
                    <div className="col">
                        <h5 className="d-print-none">
                            <Trans>Attendance</Trans>
                        </h5>
                    </div>
                    <div className="col d-flex justify-content-end">
                        <UncontrolledButtonDropdown>
                            <DropdownToggle caret color="success" className="btn-sm mx-0">
                                Import
                            </DropdownToggle>
                            <DropdownMenu>
                                {last_12_months.map((m) => (
                                    <DropdownItem onClick={() => { setSelectedMonth(m.value); openModal() }} >
                                        <Trans>{m.label}</Trans>
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </UncontrolledButtonDropdown>
                        <ImportModal
                            isOpen={isModalOpen}
                            toggle={closeModal}
                            title="Attendance"
                            handleUpload={uploadFile}
                            onDownload={download_file}
                        />
                    </div>
                </div>

                <div className="inv-tabs nw-list">
                    <Nav tabs className="nw-tabs2 inv-tabs mb-3">
                        <div onClick={() => setActiveTab('1')} className={`btn ${activeTab == '1' ? `active-tab` : ''}`}>
                            <Trans>Add Attendance for Today</Trans>
                        </div>
                        <div onClick={() => setActiveTab('2')} className={`btn ${activeTab == '2' ? `active-tab` : ''}`}>
                            <Trans>My Attendance</Trans>
                        </div>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <div className="row">
                                <div className="col-12">
                                    <AddAttendance t={t} employee={employee} />
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="row">
                                <div className="col-12">
                                    <AttendanceTable employee={employee} client={client} t={t} match={match} limit={limit} />
                                </div>
                            </div>
                        </TabPane>
                    </TabContent>
                </div>
            </CardBody>
        </Card>
    );
};

export default EmployeeAttendance;
